import React, { FunctionComponent } from "react";
import { Aside, EditButton, ListActionButtonProps, useDisclosure } from "sprint-common-web";

import { WatermarkRuleForm } from "../../forms/WatermarkRuleForm";
import { WatermarkRuleItem } from "../../WatermarkRuleItem";

export type EditWatermarkRuleButtonProps = ListActionButtonProps<WatermarkRuleItem>;

export const EditWatermarkRuleButton: FunctionComponent<EditWatermarkRuleButtonProps> = ({
    disabled,
    item
}: EditWatermarkRuleButtonProps) => {
    const { isOpen, onClose, onOpen } = useDisclosure();

    return (
        <>
            <EditButton onClick={onOpen} testId="edit-watermark-rule-button" disabled={disabled} />
            <Aside isOpen={isOpen} type="form" headerText={"Edit Watermark Rule"} onDismiss={onClose}>
                <WatermarkRuleForm item={item} onCancel={onClose} onSubmit={onClose} />
            </Aside>
        </>
    );
};
